import type { ReactNode } from "react";
import { PaperGrain } from "./PaperGrain";
import { PAPER, PAPER_TAN } from "./tokens";

// Top-level editorial page frame. Mirrors EventsPage's <main> + PaperGrain
// (EventsPage.tsx:162-167). Uses an inline bg style to match EventsPage's
// proven approach exactly. SSR-safe.
export function EditorialPage({
  bg = "paper",
  className = "",
  children,
}: {
  bg?: "paper" | "paper-tan";
  className?: string;
  children: ReactNode;
}) {
  return (
    <main
      className={`min-h-screen text-ink ${className}`.trim()}
      style={{ backgroundColor: bg === "paper-tan" ? PAPER_TAN : PAPER }}
    >
      <PaperGrain />
      {children}
    </main>
  );
}
